module.exports = __webpack_public_path__ + "img/epaper-loadError.f7c54da6.png";